import { c as _c } from "react/compiler-runtime";
import type * as SheetPrimitive from "@radix-ui/react-dialog";
import type * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Sheet, SheetContent, SheetTrigger } from "./sheet";
export function PopoverSheet(t0) {
  const $ = _c(6);
  let isDesktop;
  let props;
  if ($[0] !== t0) {
    ({
      isDesktop,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isDesktop;
    $[2] = props;
  } else {
    isDesktop = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== isDesktop || $[4] !== props) {
    t1 = isDesktop ? <Popover {...props} /> : <Sheet {...props} />;
    $[3] = isDesktop;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export function PopoverSheetTrigger(t0) {
  const $ = _c(6);
  let isDesktop;
  let props;
  if ($[0] !== t0) {
    ({
      isDesktop,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isDesktop;
    $[2] = props;
  } else {
    isDesktop = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== isDesktop || $[4] !== props) {
    t1 = isDesktop ? <PopoverTrigger {...props} /> : <SheetTrigger {...props} />;
    $[3] = isDesktop;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export function PopoverSheetContent(t0) {
  const $ = _c(6);
  let isDesktop;
  let props;
  if ($[0] !== t0) {
    ({
      isDesktop,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isDesktop;
    $[2] = props;
  } else {
    isDesktop = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== isDesktop || $[4] !== props) {
    t1 = isDesktop ? <PopoverContent {...props} /> : <SheetContent {...props} />;
    $[3] = isDesktop;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}